import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { PageMutationTypes as MutationTypes } from './mutation-types';
import { PageActionTypes as ActionTypes } from './action-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ActionTypes.SET_THREE_MODE]({ commit }: AugmentedActionContext, payload: boolean): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [ActionTypes.SET_THREE_MODE]({ commit }, payload: boolean) {
    commit(MutationTypes.SET_THREE_MODE, payload);
    commit(MutationTypes.SET_RENDERING_MODE, !payload);
  },
};
